module.exports = __webpack_public_path__ + "static/media/TeamPurple.6576340c.png";